import Vue from 'vue';
import FaqSearch from './components/FaqSearch.vue';
import './main.scss';
window.addEventListener('DOMContentLoaded', () => {
	Vue.component('FaqSearch', FaqSearch);
	new Vue({
		el: '#rwtalgyik-app'
	});
});
